import RichUpdatesPlaceholder from './RichUpdatesPlaceholder';

export default RichUpdatesPlaceholder;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesPlaceholder/index.tsx